import { render, staticRenderFns } from "./goodsMechanismCell.vue?vue&type=template&id=7996b0f4&scoped=true"
import script from "./goodsMechanismCell.vue?vue&type=script&lang=js"
export * from "./goodsMechanismCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7996b0f4",
  null
  
)

export default component.exports